export default "__VITE_PUBLIC_ASSET__ce7adb26__"